import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=5235daa6&"
import script from "./Subtitle.vue?vue&type=script&setup=true&lang=js&"
export * from "./Subtitle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=5235daa6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports